export default {
  title: 'Warenkorb',
  buttons: {
    login_to_checkout: 'Anmelden zum Bezahlen',
    checkout: 'Zur Kasse',
  },
  go_to_menu: 'Zum Menü gehen',
  toasts: {
    cashback_points_removed:
      'Dein Punktestand hat sich geändert, deshalb haben wir die Punkte aus dieser Bestellung entfernt.',
  },
};
